import type React from 'react';
import {useEffect, useState} from 'react';

export const useHasOverflow = (ref: React.RefObject<HTMLDivElement | null>) => {
    const [isOutOfBounds, setIsOutOfBounds] = useState(false);

    useEffect(() => {
        const updatePillsWidth = () => {
            if (ref.current) {
                setIsOutOfBounds(ref.current.offsetWidth < ref.current.scrollWidth);
            }
        };
        updatePillsWidth();
        const resizeObserver = new ResizeObserver(() => {
            updatePillsWidth();
        });
        if (ref.current) {
            resizeObserver.observe(ref.current);
        }
        return () => {
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
        };
    }, [ref]);

    return isOutOfBounds;
};
